<template>
  <div>
    <BRow class="mx-n2">
      <BCol class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="姓"
          rules="required"
          vid="lastName"
          v-model="inputValues.lastName"
        >
          <TextFieldGroup
            id="lastName"
            v-model="inputValues.lastName"
            label="名前"
            placeholder="介助"
            appLabelText="必須"
            type="text"
            class="mb-3"
            :disabled="isDisable"
            :validation-state="validationState"
            data-testid="lastName"
          />
        </ValidationProvider>
      </BCol>
      <BCol class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="名"
          rules="required"
          vid="firstName"
          v-model="inputValues.firstName"
        >
          <TextFieldGroup
            id="firstName"
            v-model="inputValues.firstName"
            placeholder="太郎"
            type="text"
            class="mb-3 mt-4 pt-2"
            :disabled="isDisable"
            :validation-state="validationState"
            data-testid="firstName"
          />
        </ValidationProvider>
      </BCol>
    </BRow>
    <BRow class="mx-n2">
      <BCol class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="セイ"
          rules="required|hankaku_kana"
          vid="lastNameKana"
          v-model="inputValues.lastNameKana"
        >
          <TextFieldGroup
            v-model="inputValues.lastNameKana"
            label="フリガナ"
            placeholder="カイテク"
            appLabelText="必須"
            type="text"
            class="mb-3"
            :disabled="isDisable"
            :validation-state="validationState"
            @blur="() => onBlurLastNameKana(validationState.handleChange)"
            data-testid="lastNameKana"
          />
        </ValidationProvider>
      </BCol>
      <BCol class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="メイ"
          rules="required|hankaku_kana"
          vid="firstNameKana"
          v-model="inputValues.firstNameKana"
        >
          <TextFieldGroup
            v-model="inputValues.firstNameKana"
            placeholder="タロウ"
            type="text"
            class="mb-3 mt-4 pt-2"
            :validation-state="validationState"
            :disabled="isDisable"
            @blur="() => onBlurFirstNameKana(validationState.handleChange)"
            data-testid="firstNameKana"
          />
        </ValidationProvider>
      </BCol>
    </BRow>
    <BForm>
      <ValidationProvider
        v-slot="validationState"
        name="性別"
        rules="required"
        vid="sex"
        v-model="inputValues.sex"
      >
        <FormRadioGroup
          label="性別"
          appLabelText="必須"
          name="性別"
          v-model="inputValues.sex"
          :options="genderOptions"
          class="mb-3"
          :disabled="isUnderExamination"
          :validation-state="validationState"
          data-testid="sex"
        />
      </ValidationProvider>
    </BForm>
    <label class="mr-1 text-size-14 text-mild">生年月日</label>
    <AppLabel variant="red">必須</AppLabel>
    <BRow class="mx-n2">
      <BCol cols="4" class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="誕生年"
          rules="required"
          vid="birthDateYear"
          v-model="birthDateYear"
        >
          <FormSelectGroup
            :disabled="isDisable"
            v-model="birthDateYear"
            :options="birthDateYearOptions"
            firstOption="年"
            class="mb-3"
            :validation-state="validationState"
            @mousedown="
              () => onMouseDownBirthDateYear(validationState.handleChange)
            "
            data-testid="birthDateYear"
          />
        </ValidationProvider>
      </BCol>
      <BCol cols="4" class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="誕生月"
          rules="required"
          vid="birthDateMonth"
          v-model="birthDateMonth"
        >
          <FormSelectGroup
            :disabled="isDisable"
            label=""
            v-model="birthDateMonth"
            :options="birthDateMonthOptions"
            firstOption="月"
            class="mb-3"
            :validation-state="validationState"
            data-testid="birthDateMonth"
          />
        </ValidationProvider>
      </BCol>
      <BCol cols="4" class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="誕生日"
          rules="required"
          vid="birthDateDay"
          v-model="birthDateDay"
        >
          <FormSelectGroup
            :disabled="isDisable"
            v-model="birthDateDay"
            :options="birthDateDayOptions"
            firstOption="日"
            class="mb-3"
            :validation-state="validationState"
            data-testid="birthDateDay"
            ref="birthDateDay"
          />
        </ValidationProvider>
      </BCol>
    </BRow>
    <ValidationProvider
      v-slot="validationState"
      name="メールアドレス"
      rules="required|email"
      vid="email"
      v-model="inputValues.email"
    >
      <TextFieldGroup
        v-model="inputValues.email"
        label="メールアドレス"
        placeholder="example@example.com"
        appLabelText="必須"
        :disabled="isDisable"
        type="email"
        class="mb-3"
        :validation-state="validationState"
        data-testid="email"
      />
    </ValidationProvider>
    <BRow>
      <BCol cols="12" class="mb-2">
        <p class="text-size-14 text-mild">現住所を入力してください</p>
      </BCol>
    </BRow>
    <BRow>
      <BCol cols="5">
        <ValidationProvider
          v-slot="validationState"
          name="郵便番号"
          rules="required|length:7"
          vid="postalCode"
          v-model="inputValues.postalCode"
        >
          <TextFieldGroup
            v-model="inputValues.postalCode"
            label="郵便番号"
            placeholder="1000000"
            inputmode="numeric"
            appLabelText="必須"
            type="text"
            class="mb-3"
            maxlength="7"
            :validation-state="validationState"
            :disabled="isUnderExamination"
            data-testid="postalCode"
            @change="onChangePostalCode"
          />
        </ValidationProvider>
      </BCol>
    </BRow>
    <BRow class="mx-n2">
      <BCol cols="5" class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="都道府県"
          rules="required"
          vid="prefecture"
          v-model="inputValues.prefecture"
        >
          <FormSelectGroup
            label="都道府県"
            appLabelText="必須"
            v-model="inputValues.prefecture"
            :options="prefectureOptions"
            class="mb-3"
            :validation-state="validationState"
            :disabled="isUnderExamination"
            data-testid="prefecture"
            ref="prefecture"
          />
        </ValidationProvider>
      </BCol>
      <BCol cols="7" class="px-2">
        <ValidationProvider
          v-slot="validationState"
          name="市区町村"
          rules="required"
          vid="locality"
          v-model="inputValues.locality"
        >
          <FormSelectGroup
            label="市区町村"
            appLabelText="必須"
            v-model="inputValues.locality"
            :options="localityOptions"
            class="mb-3"
            :validation-state="validationState"
            :disabled="isUnderExamination"
            data-testid="locality"
            ref="locality"
          />
        </ValidationProvider>
      </BCol>
    </BRow>
    <ValidationProvider
      v-slot="validationState"
      name="番地まで"
      rules="required"
      vid="address1"
      class="mb-3"
      v-model="inputValues.address1"
    >
      <label class="mr-1 mb-0 text-size-14 text-mild">
        番地まで
      </label>
      <AppLabel variant="red">必須</AppLabel>
      <small class="d-block mt-1 mb-2 text-size-10 text-mild">
        (市のあとに区がある地域は区から入力してください)
      </small>
      <TextFieldGroup
        v-model="inputValues.address1"
        type="text"
        :validation-state="validationState"
        :disabled="isUnderExamination"
        data-testid="address1"
        ref="address1"
      />
      <small class="text-size-12 text-mild">入力例: 港北区日吉〇-〇-〇</small>
    </ValidationProvider>
    <ValidationProvider
      v-slot="validationState"
      name="建物名・部屋番号"
      rules="max:500"
      vid="address2"
      class="mb-3"
      v-model="inputValues.address2"
    >
      <TextFieldGroup
        v-model="inputValues.address2"
        label="建物名・部屋番号"
        appLabelText="任意"
        appLabelVariant="mild"
        type="text"
        :validation-state="validationState"
        :disabled="isUnderExamination"
        data-testid="address2"
      />
      <small class="text-size-12 text-mild">入力例: △△マンション 101号</small>
    </ValidationProvider>
    <BForm v-if="showsWorkerService">
      <ValidationProvider
        v-slot="validationState"
        name="業務カテゴリ"
        rules="required"
        vid="workerService"
        v-model="inputValues.workerService"
      >
        <FormRadioGroup
          label="業務カテゴリ"
          appLabelText="必須"
          name="業務カテゴリ"
          v-model="inputValues.workerService"
          :options="workerServiceOptions"
          class="mb-3"
          :disabled="isUnderExamination"
          :validation-state="validationState"
          description="お仕事検索、資格登録で自動的に業務カテゴリに沿ったものが表示されます。マイページからいつでも変更可能です"
          data-testid="worker-service"
        />
      </ValidationProvider>
    </BForm>
  </div>
  <AddressChoiceModal
    v-if="isAddressChoiceModalShown"
    :addresses="addressOptions"
    @addressChosen="onAddressChosen"
  />
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from "vue-facing-decorator";
import FormRadioGroup from "@/components/molecules/form/FormRadioGroup.vue";
import FormSelectGroup from "@/components/molecules/form/FormSelectGroup.vue";
import AddressChoiceModal from "./AddressChoiceModal.vue";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";
import { localitiesService } from "@/app/services/LocalitiesService";
import { fullSizeToHalfSize } from "@/utils/fullSizeToHalfSize";
import AppLabel from "@/components/atoms/input/AppLabel.vue";
import { PersonalInfoQueueBody } from "@/types/user/RequestVerificationQueueBody";

// NOTE: 2023/02/13 一時的に自動フリガナ処理を止めたいとのことなのでコメントアウトで対応。
//       完全に不要ならそのまま削除してください
// import * as AutoKana from "vanilla-autokana";
import { defaultBirthDate } from "@/const/defaultBirthDate";
import { CustomFormOption } from "@/types/form/FormOption";
import { HandleChangeType } from "@/types/Validation";
import {
  endOfMonth,
  formatFromUnixTimestamp,
  getYear,
  isValid,
  now,
  parseISO,
  splitDate
} from "@/utils/date";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { captureException } from "@/plugins/sentry";
import { Address } from "@/types/locality/Address";
import { h } from "vue";
import { authStore } from "@/store/auth";
import { masterStore } from "@/store/master";
import { WORKER_SERVICE_ID_CHILDCARE } from "@/const/workerService";

@Component({
  components: {
    FormRadioGroup,
    AddressChoiceModal,
    FormSelectGroup,
    TextFieldGroup,
    AppLabel,
    AppButton
  }
})
export default class PersonalInfo extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  value!: PersonalInfoQueueBody;

  @Prop({
    type: Boolean,
    default: false
  })
  disableV1UserInformation!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isUnderExamination!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  showsWorkerService!: boolean;

  @Prop({
    type: Boolean,
    default: true
  })
  fromRegister!: boolean;

  birthDateYear: number | null = null;
  birthDateMonth: number | null = null;
  birthDateDay: number | null = null;
  localityOptions: CustomFormOption<number>[] = [];

  isAddressChoiceModalShown = false;
  addressOptions: Address[] = [];
  onAddressChosen: ((addr: Address | null) => void) | null = null;

  // NOTE: 2023/02/13 一時的に自動フリガナ処理を止めたいとのことなのでコメントアウトで対応。
  //       完全に不要ならそのまま削除してください
  // autoKanaLastName: AutoKana.AutoKana | null = null;
  // autoKanaFirstName: AutoKana.AutoKana | null = null;

  get defaultBirthDate() {
    return defaultBirthDate;
  }

  get isDisable() {
    return this.disableV1UserInformation || this.isUnderExamination;
  }

  get prefectureOptions() {
    return masterStore.prefectures.map(prefecture => ({
      value: prefecture.id.toString(),
      text: prefecture.prefecture
    }));
  }

  get genderOptions() {
    return [
      { value: "1", text: "男性" },
      { value: "2", text: "女性" }
    ];
  }

  get birthDateYearOptions() {
    const currentYear = getYear(now());
    const yearOptions = Array.from({ length: 100 }, (_, i) => {
      const year = currentYear - i;
      return { value: year, text: `${year}年` };
    }).reverse();
    return yearOptions;
  }

  get birthDateMonthOptions() {
    const monthOptions = Array.from({ length: 12 }, (_, i) => {
      const month = i + 1;
      return { value: month, text: `${month}月` };
    });
    return monthOptions;
  }

  get birthDateDayOptions() {
    const year = this.birthDateYear || this.defaultBirthDate.YEAR;
    const month = this.birthDateMonth || this.defaultBirthDate.MONTH;
    // 月末日を取得
    const lastDayOfMonth = Number(
      formatFromUnixTimestamp(
        endOfMonth(parseISO(`${year}-${month.toString().padStart(2, "0")}-01`)),
        "d"
      )
    );
    const dayOptions = Array.from({ length: lastDayOfMonth }, (_, i) => {
      const day = i + 1;
      return { value: day, text: `${day}日` };
    });
    return dayOptions;
  }

  get inputValues() {
    return this.value;
  }

  set inputValues(v) {
    if (this.value !== v) this.$emit("input", v);
  }

  get workerServiceOptions() {
    const baseOptions = authStore.workerServiceOptionsByProduct;

    // TODO: 保育案件特需対応
    // 擬似的＆一時的に「保育」の選択肢を追加
    if (this.fromRegister) {
      return [
        ...baseOptions,
        { value: WORKER_SERVICE_ID_CHILDCARE, text: "保育" }
      ];
    }

    return baseOptions;
  }

  @Watch("inputValues.birthDate", { immediate: true })
  onChangeInputValuesBirthDate() {
    if (!this.inputValues.birthDate) return;
    const [year, month, day] = splitDate(this.inputValues.birthDate, "-");
    this.birthDateYear = year;
    this.birthDateMonth = month;
    this.birthDateDay = day;
  }

  @Watch("birthDateDay")
  onChangeBirthDate() {
    this.inputValues.birthDate = this.formatBirthDate();
  }

  @Watch("birthDateYear")
  @Watch("birthDateMonth")
  onChangeBirthDateMonth() {
    if (!this.birthDateDay) return;
    // 選択した月に存在しない日付が入力されていた場合、未入力に戻す
    if (!this.birthDateDayOptions.some(o => o.value === this.birthDateDay)) {
      this.birthDateDay = null;
      // NOTE: 誕生日のバリデーションを走らせるために handleChange を呼ぶ
      (this.$refs.birthDateDay as FormSelectGroup).validationState.handleChange(
        null,
        false
      );
      return;
    }
    this.inputValues.birthDate = this.formatBirthDate();
  }

  @Watch("inputValues.prefecture", { immediate: true })
  async onChangePrefecture(prefecture: string) {
    if (!prefecture) return;
    const localities = await localitiesService.fetchLocalitiesWithSeirei(
      Number(prefecture)
    );
    const localityOptions = localities
      // 政令指定都市は選択肢に表示しない
      // ただしすでに選択されている政令指定都市は表示する
      .filter(l => !l.isSeirei || this.inputValues.locality === l.id)
      .map(locality => ({
        value: locality.id,
        text: locality.city
      }));
    this.localityOptions = localityOptions;
    // 違う都道府県が選択された場合、未入力に戻す
    if (
      !localityOptions.some(
        option => option.value === this.inputValues.locality
      )
    ) {
      this.inputValues.locality = null;
      // NOTE: 市区町村のバリデーションを走らせるために handleChange を呼ぶ
      (this.$refs.locality as FormSelectGroup).validationState.handleChange(
        null,
        false
      );
    }
  }

  // addressesと現在入力値が一致するか確認する
  isSameAddress(addresses: Address[]) {
    return addresses.some(address => {
      return (
        address.prefectureId === this.inputValues.prefecture &&
        address.localityId === this.inputValues.locality
      );
    });
  }

  isInputValuesEmpty() {
    return (
      !this.inputValues.prefecture &&
      !this.inputValues.locality &&
      !this.inputValues.address1
    );
  }

  updateInputValuesByAddresses(addresses: Address[]) {
    const update = (address: Address) => {
      this.inputValues.prefecture = address.prefectureId;
      this.inputValues.locality = address.localityId;
      this.inputValues.address1 = address.town;

      // NOTE: 都道府県でrequiredバリデーションが走るために handleChange を呼ぶ
      (this.$refs.prefecture as FormSelectGroup).validationState.handleChange(
        this.inputValues.prefecture,
        true
      );
      // NOTE: 市区町村でrequiredバリデーションが走るために handleChange を呼ぶ
      (this.$refs.locality as FormSelectGroup).validationState.handleChange(
        this.inputValues.locality,
        true
      );
      // NOTE: 番地まででrequiredバリデーションが走るために handleChange を呼ぶ
      (this.$refs.address1 as TextFieldGroup).validationState.handleChange?.(
        this.inputValues.address1,
        true
      );
    };

    if (addresses.length === 1) {
      // 1件ヒット時、そのまま住所を入力
      update(addresses[0]);
      return;
    } else {
      // 複数件ヒット時、住所を選択する
      this.isAddressChoiceModalShown = true;
      this.addressOptions = addresses;
      this.onAddressChosen = (addr: Address | null) => {
        this.isAddressChoiceModalShown = false;
        if (!addr) return;
        update(addr);
      };
      return;
    }
  }

  // 郵便番号から住所を保管する
  async updateAddressByPostalCode() {
    // 7桁の数字以外は無視する
    if (!/^\d{7}$/.test(this.inputValues.postalCode)) {
      return;
    }
    try {
      // ユーザの入力の気を逸らさないためにloadingはあえて表示しない
      const addresses = (
        await localitiesService.searchPostalCode(this.inputValues.postalCode)
      ).body;
      if (addresses.length === 0) {
        await this.$bvModal.msgBoxOk("該当する住所が見つかりませんでした", {
          centered: true
        });
        return;
      }

      if (this.isInputValuesEmpty()) {
        // 住所が未入力の場合、郵便番号から取得した住所を入力する
        this.updateInputValuesByAddresses(addresses);
      } else {
        // 住所が入力済みの場合、住所が一致するか確認する
        if (this.isSameAddress(addresses)) {
          // 一致する場合は何もしない
          return;
        } else {
          // 一致しない場合は確認ダイアログを表示する

          await this.$bvModal.msgBoxOk(
            [
              h("div", ["申し訳ございません。"]),
              h("div", [
                "郵便番号と市区町村が一致しないため、郵便番号から取得した住所に変更します。"
              ])
            ],
            {
              centered: true
            }
          );
          this.updateInputValuesByAddresses(addresses);
        }
      }
    } catch (e) {
      // エラーが発生しても致命的なエラーではないため、エラーログを送信するだけに留める
      captureException(e as Error);
    }
  }

  formatBirthDate() {
    if (!this.birthDateYear || !this.birthDateMonth || !this.birthDateDay) {
      return null;
    }
    const date = parseISO(
      `${this.birthDateYear}-${this.birthDateMonth
        .toString()
        .padStart(2, "0")}-${this.birthDateDay.toString().padStart(2, "0")}`
    );
    if (!isValid(date)) {
      return null;
    }
    return formatFromUnixTimestamp(date, "yyyy-MM-dd");
  }

  onBlurLastNameKana(handleChange: HandleChangeType) {
    this.inputValues.lastNameKana = fullSizeToHalfSize(
      this.inputValues.lastNameKana || ""
    );
    handleChange(this.inputValues.lastNameKana, true);
  }

  onBlurFirstNameKana(handleChange: HandleChangeType) {
    this.inputValues.firstNameKana = fullSizeToHalfSize(
      this.inputValues.firstNameKana || ""
    );
    handleChange(this.inputValues.firstNameKana, true);
  }

  onMouseDownBirthDateYear(handleChange: HandleChangeType) {
    // NOTE: デフォルトのスクロール位置を変更するため mousedown された際にデフォルト生年月日を入れる。
    if (this.birthDateYear === null) {
      this.birthDateYear = defaultBirthDate.YEAR;
      handleChange(this.birthDateYear, true);
    }
  }

  async onChangePostalCode() {
    await this.updateAddressByPostalCode();
  }

  onClickBack() {
    this.$router.back();
  }

  onClickSubmit() {
    this.$emit("submit");
  }
}
</script>

<style lang="scss" scoped>
.complement-button {
  margin-top: 2.2rem;
}
</style>
